import { matchers } from "../validate-props/matchers";

/**
 *  Creates a 1 depth object
 *
 * @param {Object} obj
 * @param {Boolean} checkConflict define whether or not to throw error when conflicts
 * are found during the flatten
 * @throws {Error} on prop conflicts + $checkConflic = true
 * @returns {Object}
 */
export function flattenObject(obj, checkConflict) {
    // We only want to handle object.
    if (!matchers.object(obj)) return null;

    const flatten = (origin, target) => {
        return Object.keys(origin).reduce((acc, key) => {
            // Alert and fail when conflicting with existent tokens.
            if (checkConflict === true && acc[key] !== undefined) {
                throw new Error(
                    `!Property conflict! The key:${key} was already defined with: ${acc[key]}`
                );
            } else if (
                origin[key] &&
                typeof origin[key] === "object" &&
                !Array.isArray(origin[key])
            ) {
                acc = flatten(origin[key], acc);
            } else {
                acc[key] = origin[key];
            }
            return acc;
        }, target);
    };

    return flatten(obj, {});
}
